import React from 'react';

// Shared button (FECOA-2174). Pass `as={Link}` and `to` for a link that looks
// like a button.
const VARIANTS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  danger: 'btn-danger',
  'danger-soft': 'btn-danger-soft',
};

const SIZES = { sm: 'btn-sm', md: '', lg: 'btn-lg' };

const Button = React.forwardRef(
  ({ as: Component = 'button', variant = 'primary', size = 'md', icon: Icon, iconOnly = false, className = '', children, type, ...props }, ref) => {
    const classes = ['btn', VARIANTS[variant] || VARIANTS.primary, SIZES[size] || '', iconOnly ? 'btn-icon' : '', className]
      .filter(Boolean)
      .join(' ');
    const buttonType = Component === 'button' ? type || 'button' : type;
    return (
      <Component ref={ref} className={classes} type={buttonType} {...props}>
        {Icon && <Icon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} strokeWidth={2} aria-hidden="true" />}
        {children}
      </Component>
    );
  },
);

Button.displayName = 'Button';

export default Button;
